import styled from 'styled-components/native';

export const SectionContainer = styled.View``;
